import * as z from "zod/mini";
import { makeApiResource } from "./resource";
import { skillSchema } from "./skills";

const sharedAttributes = { name: z.string(), description: z.nullable(z.string()) };

const timeBlockSchema = makeApiResource({ ...sharedAttributes, start_time: z.string(), end_time: z.string() });

export const proContractorTypeSchema = makeApiResource(sharedAttributes);

const hoursPerWeekSchema = makeApiResource(sharedAttributes);

const daysOfWeek = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"] as const;
export const proPreferencesSchema = makeApiResource({
  pro_contractor_type: z.nullish(
    z.array(z.extend(proContractorTypeSchema, { id: z.nullish(z.number()), description: z.nullish(z.string()) })),
  ),
  skills: z.nullish(z.array(skillSchema)),
  days_of_week: z.nullish(z.array(z.enum(daysOfWeek))),
  time_blocks: z.nullish(z.array(timeBlockSchema)),
  hours_per_week: z.nullish(z.array(hoursPerWeekSchema)),
});
